/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo } from "react";
import useStyles from "./styles";
import NoneNoti from "../NoneNoti";

import { Grid, IconButton } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { Images } from "config/images";
import { NOTIFICATION_TYPE } from "config/constant";

const NotificationItem = props => {
	const { notifications, postWatchedNotification, listLoyalty } = props;
	const classes = useStyles();
	const history = useHistory();

	const handleNext = notification => {
		const type = notification?.content?.type;
		if (!notification?.watched) {
			postWatchedNotification(notification?.id);
		}
		switch (type) {
			case "CHANGE_ORDER_STATUS": {
				history.push(
					`order_history_detail?id=${notification?.id}&business=TAC`
				);
				break;
			}
			case "CRM_ORDER": {
				history.push(
					`order_history_detail?id=${notification?.id}&business=TAC`
				);
				break;
			}
			case "PROMOTION": {
				history.push(`/promotion_detail?id=${notification?.id}`);
				break;
			}
			case "MERCHANDISING_IMAGE": {
				history.push("/special_offer");
				break;
			}
			case "MERCHANDISING": {
				// history.push(
				// 	`/special_offer?id=${notification?.content?.campaignId}&type=${type}`
				// );
				history.push(
					`/merchandising_detail?id=${notification?.content?.campaignId}`
				);
				break;
			}
			case "NEW": {
				history.push(`news?id=${notification?.id}&business=TAC`);
				break;
			}
			case "LOYALTY": {
				const campaignId = notification?.content?.campaignId;
				const loyaltyDetail = listLoyalty?.find(
					item => item?.id === campaignId
				);
				if (loyaltyDetail?.type === "GIFT") {
					history.push(
						`/special_offer?id=${campaignId}&type=${loyaltyDetail?.type}`
					);
				} else {
					history.push(`/special_offer_detail?id=${campaignId}`);
				}
				break;
			}
			case "UPDATE_SYSTEM": {
				history.push(`news?id=${notification?.id}&business=TAC`);
				break;
			}
			case "FORCE_UPDATE": {
				history.push(`news?id=${notification?.id}&business=TAC`);
				break;
			}
			default:
				history.push("/home");
				break;
		}
	};

	return (
		<Grid classes={{ root: classes.root }}>
			{notifications.length > 0 ? (
				notifications?.map((notification, index) => {
					return (
						<Grid
							container
							justifyContent="center"
							key={index}
							style={{
								opacity: !notification?.watched ? 1 : 0.7
							}}
							classes={{ root: classes.border }}
							onClick={() => handleNext(notification)}
						>
							<Grid style={{ width: "10%" }}>
								<img
									src={
										NOTIFICATION_TYPE[
											notification?.content?.type
										]?.image
									}
									alt={`${
										NOTIFICATION_TYPE[
											notification?.content?.type
										]?.type
									}_image`}
								/>
							</Grid>
							<Grid style={{ width: "80%" }}>
								<Grid style={{ padding: "0px 10px" }}>
									<Grid
										container
										justifyContent="space-between"
										style={{ marginBottom: 5 }}
									>
										<Grid classes={{ root: classes.title }}>
											{
												NOTIFICATION_TYPE[
													notification?.content?.type
												]?.name
											}
										</Grid>
										{!notification?.watched && (
											<Grid
												classes={{ root: classes.tag }}
											>
												Mới
											</Grid>
										)}
									</Grid>
									<Grid
										classes={{ root: classes.text }}
										style={{
											whiteSpace: "pre-wrap"
										}}
										dangerouslySetInnerHTML={{
											__html: notification?.content
												?.subTitle
										}}
									/>
									<Grid classes={{ root: classes.textTime }}>
										{notification?.previousTime}
									</Grid>
								</Grid>
							</Grid>
							<Grid style={{ width: "10%" }}>
								<IconButton>
									<img
										src={Images.icNextNoti}
										alt={"icNextNoti"}
									/>
								</IconButton>
							</Grid>
						</Grid>
					);
				})
			) : (
				<NoneNoti />
			)}
		</Grid>
	);
};

export default memo(NotificationItem);
